import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { haptic } from '../../hooks/useTelegram';
import { useConfig } from '../../hooks/useConfig';
import { mockFaq } from '../../lib/mock';
import { ChevronRight } from '../icons';

/** FAQ screen (Profile → FAQ) — accordion list. Content comes from the API
 *  (admin-editable, bilingual); falls back to the mock while it loads. */
export function FaqScreen() {
  const { t, i18n } = useTranslation();
  const { config } = useConfig();
  const [open, setOpen] = useState<number | null>(null);
  const lang = i18n.language?.startsWith('ru') ? 'ru' : 'en';
  const faq = config?.faq ?? mockFaq;

  return (
    <div className="push-enter flex min-h-full flex-col bg-surface px-4 pb-16 pt-3">
      <header className="flex items-center py-2">
        <h1 className="text-[20px] font-medium text-ink">{t('profile.faq')}</h1>
      </header>

      {faq.length === 0 ? (
        <div className="mt-24 text-center text-[14px] text-muted">{t('help.faqEmpty')}</div>
      ) : (
        <div className="mt-3 flex flex-col gap-[10px]">
          {faq.map((it, i) => {
            const isOpen = open === i;
            return (
              <div key={i} className="overflow-hidden rounded-[18px] bg-card shadow-card">
                <button
                  onClick={() => {
                    haptic();
                    setOpen(isOpen ? null : i);
                  }}
                  className="flex w-full items-center justify-between gap-3 p-4 text-left active:opacity-70"
                >
                  <span className="text-[15px] font-medium text-ink">{it.q[lang]}</span>
                  <ChevronRight
                    width={18}
                    height={18}
                    className={`shrink-0 text-muted transition-transform duration-300 ${
                      isOpen ? 'rotate-90' : ''
                    }`}
                  />
                </button>
                {isOpen && (
                  <p className="whitespace-pre-line px-4 pb-4 text-[14px] leading-relaxed text-muted">
                    {it.a[lang]}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
